/**
 * Featured-listing promotion packages.
 *
 * Prices are SERVER-AUTHORITATIVE. The browser sends only the `days` selector;
 * the server reads the matching amount from this table before creating a
 * Stripe Checkout Session. Do not accept prices from client input.
 */
export type PromotionPackage = {
  days: 3 | 7 | 14;
  amount_pence: number;
  label: string;
  description: string;
};

export const PROMOTION_PACKAGES: readonly PromotionPackage[] = [
  { days: 3, amount_pence: 199, label: "3 days", description: "Featured for 3 days" },
  { days: 7, amount_pence: 399, label: "7 days", description: "Featured for 7 days" },
  { days: 14, amount_pence: 699, label: "14 days", description: "Featured for 14 days" },
] as const;

export function getPromotionPackage(days: number): PromotionPackage | null {
  return PROMOTION_PACKAGES.find((p) => p.days === days) ?? null;
}
